import { isLoaded, isLoading } from "../actions";
import Alert from "../../Alert";
import API from "../../Network/API";

//add template from template
export async function createTemplate(state, dispatch, getUser,handleClose, storyTitle, MAINTASK_ADD) {
    if (storyTitle !== state.taskTitle.value){
    dispatch(isLoading());
    if (state.taskTitle.value === "" && state.id.value === "") {
      Alert("warning", "Please enter required fields")
      dispatch(isLoaded());
    }
    else if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
      try {
        var response = await API.post("manage_template.php", {
          crop: getUser.corp,
          action: "add",
          title: state.taskTitle.value,
          description: state.taskDescription.value,
          added_by: getUser.empId,
          acceptanceCriteria: state.acceptanceCriteria.value,
          "projectId":getUser.projectId,
          device_id: state.device_id,
          player_id: state.player_id,
          added_to: state.userSelected === "" ? state.id.value : state.userSelected,
          storyPoints: state.storySelected === "" ? state.storyPoints.value : state.storySelected,
          priorityLevel: state.prioritySelected === "" ? state.priorityLevel.value : state.prioritySelected,
          idea_id: state.epicSelected === "" ? state.ideaId.value : state.epicSelected,
  
        }, {}, false);
        if (response.status === 'True') {
          Alert("success", MAINTASK_ADD);
          handleClose();
        }
        else if(response.status === 'false' && response.message ==="TemplateExisted"){
          dispatch(isLoaded());
          Alert("warning", "Template already existed!, Please change user template title");
        }
      } catch (error) {
        Alert('error', error.message);
        dispatch(isLoaded());
      }
    }
   
    else {
      Alert("warning", "Please enter required fields ")
      dispatch(isLoaded());
    }
  }else{
    Alert("warning", "Please change user story title ")
      dispatch(isLoaded());
  }
  }